import {
  TUseWorkRequestsFilter,
  TWorkRequestsWorkRequest,
} from '@commenda/types/src/work-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

const useWorkRequests = (workRequestsFilter: TUseWorkRequestsFilter) => {
  const query = new URLSearchParams();

  const { assignedCAFirmId, companyId, types, includeFiles } =
    workRequestsFilter;

  if (assignedCAFirmId) query.append('assignedCAFirmId', assignedCAFirmId);
  if (companyId) query.append('companyId', companyId.toString());
  if (types) query.append('types', types.join(','));
  if (includeFiles) query.append('includeFiles', includeFiles.toString());

  const {
    data,
    error,
    mutate,
  }: {
    data?: TWorkRequestsWorkRequest[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `workRequest/getAll?${query}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, mutate };
};

export default useWorkRequests;
